import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()

export class LeadsService {
  
	LEADS_URI: string = environment.apiUrl + '/lead';

	constructor(private httpClient: HttpClient) {}

	public getLeadsByForm = (id) => {
		return this.httpClient.get(this.LEADS_URI + `/${id}`);
	}

	public getLeadsByFilter = (body) => {
		return this.httpClient.post(this.LEADS_URI + `/byAction`, body);
	}
  
  public update = (body) => {
		return this.httpClient.put(this.LEADS_URI, body);
	}
	
	public getMetrics = (body) => {
		return this.httpClient.post(this.LEADS_URI + `/metrics`, body);
	}

	public getLeadsByPage = (body) => {
		
		return this.httpClient.post(this.LEADS_URI + `/test`, body);
	}
  
}


// WEBPACK FOOTER //
// ./src/app/services/leads.service.ts